// Auto-resolve duplicate invoices based on document quality classification
// Returns: { action: 'auto_swap'|'manual_review', reason: string, keepNew: boolean }

export function resolveDuplicate(existingInv, newExtracted) {
  const existingQuality = existingInv.doc_quality || 'unknown';
  const existingConf = existingInv.doc_quality_confidence ?? 0;
  const newQuality = newExtracted.document_quality || 'unknown';
  const newConf = newExtracted.document_quality_confidence ?? 0;
  const existingTotal = Number(existingInv.grand_total || 0);
  const newTotal = Number(newExtracted.grand_total || 0);
  const totalDiff = Math.abs(newTotal - existingTotal);

  // Resolve document timestamp for "newer" comparison
  // Prefer document's own printed/delivery timestamp; fall back to created_at
  const existingDate = existingInv.doc_timestamp || existingInv.created_at || '';
  const newDate = newExtracted.document_timestamp || new Date().toISOString();

  // Rule 4: Low confidence → manual review
  if ((existingQuality !== 'unknown' && existingConf < 0.7) || (newQuality !== 'unknown' && newConf < 0.7)) {
    return { action: 'manual_review', reason: 'Low confidence in document quality classification', keepNew: null };
  }

  // Rule 1: Final beats preview
  if (newQuality === 'final' && existingQuality === 'preview') {
    return { action: 'auto_swap', reason: 'New copy is signed delivery ticket; existing is a portal printout', keepNew: true };
  }
  if (existingQuality === 'final' && newQuality === 'preview') {
    return { action: 'auto_swap', reason: 'Existing copy is signed delivery ticket; new is a portal printout', keepNew: false };
  }

  // Rule 3: Totals differ + type unclear → manual review
  if (totalDiff > 0.50 && (existingQuality === 'unknown' || newQuality === 'unknown' || existingQuality === newQuality)) {
    return { action: 'manual_review', reason: `Totals differ by $${totalDiff.toFixed(2)} and document types are both ${existingQuality}`, keepNew: null };
  }

  // Rule 2: Same type (or both unknown), totals within $0.50 → newer wins
  if (totalDiff <= 0.50) {
    const keepNew = newDate >= existingDate;
    return {
      action: 'auto_swap',
      reason: keepNew
        ? `Both documents are ${newQuality}; newer copy (${newDate}) kept`
        : `Both documents are ${newQuality}; existing copy (${existingDate}) is newer — kept`,
      keepNew,
    };
  }

  // Fallback: manual review
  return { action: 'manual_review', reason: 'Could not auto-resolve', keepNew: null };
}
